import { render } from "./FocusedLayout.vue?vue&type=template&id=86a4a7d2&scoped=true"
const script = {}

import "./FocusedLayout.vue?vue&type=style&index=0&id=86a4a7d2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86a4a7d2"]])

export default __exports__